import { Outlet } from 'react-router-dom';
import { RegistrationProvider } from '../components/layouts/app/RegistrationContext';
import ForcePasswordChangeModal from '../components/ui/ForcePasswordChangeModal';
import AuthMiddleware from './AuthMiddleware';

/** Auth + registration modals wrap all parent dashboard pages so hooks work. */
export default function ParentDashboardLayout() {
    return (
        <AuthMiddleware>
            <RegistrationProvider>
                <Outlet />
                <ForcePasswordChangeModal />
            </RegistrationProvider>
        </AuthMiddleware>
    );
}
